import { render, staticRenderFns } from "./GoalPreview.vue?vue&type=template&id=4de625ac&"
import script from "./GoalPreview.vue?vue&type=script&lang=ts&"
export * from "./GoalPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports